export default __webpack_public_path__ + "static/media/square-2.a9abf4b3.svg";